export const universities = {
  USA: [
    {
      "name": "Washington University of Science and Technology",
      "location": "Vienna, Virginia, USA",
      "tuition": 15000,
      "livingCost": 9750,
      "description": "A private university specializing in science, technology, and business education with a focus on practical learning.",
      "ranking": "Regional",
      "type": "Private",
      "images": ["Images/USA/Washington University of Science and Technology/campus.jpg"],
      "programs": ["Computer Science", "Business Administration", "Cybersecurity", "Data Science"],
      "features": ["STEM-Focused", "Industry Partnerships", "Career-Oriented Programs", "Small Class Sizes"]
    },
    {
      "name": "California State University",
      "location": "Multiple Campuses, California, USA",
      "tuition": 17700,
      "livingCost": 10400,
      "description": "One of the largest public university systems in the U.S., offering quality education across 23 campuses.",
      "ranking": "Varies by Campus",
      "type": "Public",
      "images": ["Images/USA/California Institute of Technology (Caltech)/campus.jpg"],
      "programs": ["Engineering", "Business", "Education", "Health Sciences"],
      "features": ["Affordable Tuition", "Diverse Programs", "Strong Industry Connections", "Research Opportunities"]
    },
    {
      "name": "DePaul University",
      "location": "Chicago, Illinois, USA",
      "tuition": 43800,
      "livingCost": 9750,
      "description": "A private Catholic university known for its strong programs in business, law, and technology, located in the heart of Chicago.",
      "ranking": "127",
      "type": "Private",
      "images": ["Images/USA/DePaul University/campus.jpg"],
      "programs": ["Business", "Law", "Computer Science", "Media Studies"],
      "features": ["Chicago Location", "Industry Partnerships", "Career-Oriented Education", "Diverse Student Body"]
    },
    {
      "name": "Arkansas State University",
      "location": "Jonesboro, Arkansas, USA",
      "tuition": 13200,
      "livingCost": 7800,
      "description": "A public research university offering a variety of undergraduate and graduate programs with a focus on applied learning.",
      "ranking": "299",
      "type": "Public",
      "images": ["Images/USA/Arkansas State University/campus.jpg"],
      "programs": ["Agriculture", "Business", "Engineering", "Health Sciences"],
      "features": ["Affordable Education", "Research Excellence", "Vibrant Campus Life", "Diverse Programs"]
    },
    {
      "name": "Wright State University",
      "location": "Dayton, Ohio, USA",
      "tuition": 9920,
      "livingCost": 11050,
      "description": "A public university known for its strong engineering, business, and medical programs, with a focus on research and innovation.",
      "ranking": "298",
      "type": "Public",
      "images": ["Images/USA/Wright State University/campus.jpg"],
      "programs": ["Engineering", "Business", "Health Sciences", "Education"],
      "features": ["STEM-Focused", "Research Opportunities", "Diverse Student Body", "Strong Community Engagement"]
    },
    {
      "name": "Weber State University",
      "location": "Ogden, Utah, USA",
      "tuition": 8700,
      "livingCost": 9750,
      "description": "A public university offering high-quality education with a strong emphasis on practical learning and career preparation.",
      "ranking": "Regional Top 50",
      "type": "Public",
      "images": ["Images/USA/Weber State University/campus.jpg"],
      "programs": ["Business", "Engineering", "Nursing", "Computer Science"],
      "features": ["Affordable Tuition", "Hands-On Learning", "Diverse Programs", "Small Class Sizes"]
    },
    {
      "name": "Webster University",
      "location": "St. Louis, Missouri, USA",
      "tuition": 29500,
      "livingCost": 12350,
      "description": "A private university with a global perspective, offering flexible programs designed for working professionals and international students.",
      "ranking": "Regional Top 20",
      "type": "Private",
      "images": ["Images/USA/Webst/campus.jpg"],
      "programs": ["Business", "International Relations", "Psychology", "Media Studies"],
      "features": ["Global Campus Network", "Flexible Programs", "Career-Oriented Education", "Diverse Student Body"]
    },
    {
      "name": "University of South Florida",
      "location": "Tampa, Florida, USA",
      "tuition": 17324,
      "livingCost": 13650,
      "description": "A top-tier public research university offering innovative programs in business, engineering, and health sciences.",
      "ranking": "89",
      "type": "Public",
      "images": ["Images/USA/University of South Florida/campus.jpg"],
      "programs": ["Business", "Engineering", "Health Sciences", "Marine Science"],
      "features": ["Research Excellence", "Diverse Student Body", "Strong Industry Partnerships", "Tropical Campus Environment"]
    },
    {
      name: "University of South Dakota",
      location: "Vermillion, South Dakota, USA",
      tuition: 12250,
      livingCost: 11700,
      description: "A public research university known for its strong programs in law, business, and health sciences.",
      ranking: "298",
      type: "Public",
      images: ["Images/USA/University of South Dakota/campus.jpg"],
      programs: ["Business", "Law", "Health Sciences", "Education"],
      features: ["Affordable Tuition", "Strong Research Programs", "Student-Centered Learning", "Vibrant Campus Life"]
    },
    {
      name: "California Institute of Technology (Caltech)",
      location: "Pasadena, California, USA",
      tuition: 60717,
      livingCost: 14300,
      description: "A world-renowned private research university specializing in science, engineering, and technology.",
      ranking: "4",
      type: "Private",
      images: ["Images/USA/California Institute of Technology (Caltech)/campus.jpg"],
      programs: ["Physics", "Engineering", "Computer Science", "Mathematics"],
      features: ["STEM Focus", "Nobel Laureates", "Cutting-Edge Research", "Small Class Sizes"]
    },
    {
      name: "Youngstown State University",
      location: "Youngstown, Ohio, USA",
      tuition: 10400,
      livingCost: 10400,
      description: "A public university offering diverse academic programs with a strong emphasis on applied learning.",
      ranking: "331",
      type: "Public",
      images: ["Images/USA/California Institute of Technology (Caltech)/campus.jpg"],
      programs: ["Engineering", "Business", "Health Sciences", "Education"],
      features: ["Affordable Education", "Career-Focused Programs", "Diverse Student Body", "Strong Community Engagement"]
    },
    {
      name: "Texas State University",
      location: "San Marcos, Texas, USA",
      tuition: 11860,
      livingCost: 13000,
      description: "A large public university known for its research, innovation, and strong academic programs.",
      ranking: "280",
      type: "Public",
      images: ["Images/USA/Texas State University/campus.jpg"],
      programs: ["Business", "Engineering", "Psychology", "Education"],
      features: ["Research Excellence", "Vibrant Campus Life", "Strong Alumni Network", "Beautiful Hill Country Setting"]
    },
    {
      name: "University of Jamestown",
      location: "Jamestown, North Dakota, USA",
      tuition: 23600,
      livingCost: 11050,
      description: "A private liberal arts university focused on personalized education and student success.",
      ranking: "Regional Top 50",
      type: "Private",
      images: ["Images/USA/University of Jamestown/campus.jpg"],
      programs: ["Nursing", "Business", "Education", "Liberal Arts"],
      features: ["Small Class Sizes", "Strong Community", "Personalized Education", "Liberal Arts Tradition"]
    },
    {
      "name": "George Mason University",
      "location": "Fairfax, Virginia, USA",
      "tuition": 37310,
      "livingCost": 14300,
      "description": "A leading public research university in Virginia, known for its strong programs in economics, law, and cybersecurity.",
      "ranking": "137",
      "type": "Public",
      "images": ["Images/USA/George Mason University/campus.jpg"],
      "programs": ["Cybersecurity", "Law", "Economics", "Engineering"],
      "features": ["Research Excellence", "D.C. Proximity", "Diverse Student Body", "Strong Industry Ties"]
    },
    {
      "name": "Florida International University",
      "location": "Miami, Florida, USA",
      "tuition": 18566,
      "livingCost": 13650,
      "description": "A top-tier public research university with a strong focus on business, international relations, and engineering.",
      "ranking": "151",
      "type": "Public",
      "images": ["Images/USA/Florida International University/campus.jpg"],
      "programs": ["Business", "Engineering", "International Relations", "Marine Science"],
      "features": ["Global Perspective", "Diverse Campus", "Strong Research Focus", "Miami Location"]
    },
    {
      "name": "San Diego State University",
      "location": "San Diego, California, USA",
      "tuition": 20412,
      "livingCost": 15600,
      "description": "A top public research university known for business, engineering, and international studies.",
      "ranking": "151",
      "type": "Public",
      "images": ["https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?auto=format&fit=crop&q=80"],
      "programs": ["Business", "Engineering", "Health Sciences", "Psychology"],
      "features": ["Coastal Campus", "High Research Activity", "Diverse Programs", "Sunny Weather"]
    },
    {
      "name": "University of Alabama at Birmingham",
      "location": "Birmingham, Alabama, USA",
      "tuition": 20500,
      "livingCost": 12350,
      "description": "A research-intensive public university, highly regarded for its medical and health science programs.",
      "ranking": "142",
      "type": "Public",
      "images": ["Images/USA/University of Alabama at Birmingham/campus.jpg"],
      "programs": ["Medicine", "Business", "Engineering", "Public Health"],
      "features": ["Medical Research Hub", "Urban Campus", "Diverse Student Body", "Cutting-Edge Facilities"]
    },
    {
      "name": "Portland State University",
      "location": "Portland, Oregon, USA",
      "tuition": 29000,
      "livingCost": 14300,
      "description": "A metropolitan public university known for its strong urban studies, engineering, and sustainability programs.",
      "ranking": "National Tier 2",
      "type": "Public",
      "images": ["Images/USA/Portland State University/campus.jpg"],
      "programs": ["Urban Studies", "Engineering", "Business", "Sustainability"],
      "features": ["Urban Campus", "Research Excellence", "Industry Connections", "Innovative Learning"]
    },
    {
      "name": "University of North Texas",
      "location": "Denton, Texas, USA",
      "tuition": 19600,
      "livingCost": 13000,
      "description": "A public research university known for its music, business, and engineering programs.",
      "ranking": "132",
      "type": "Public",
      "images": ["Images/USA/University of North Texas/campus.jpg"],
      "programs": ["Music", "Business", "Engineering", "Computer Science"],
      "features": ["Music Excellence", "Strong Research Focus", "Large Student Body", "Dallas Proximity"]
    }
  ]
};
